const TestimonialApi = [
  // {
  //   id: 1,
  //   image: "./image/slide1.png",
  //   design: "CCE - Developer",
  //   name: "Mr. Hamza Mansour",
  //   offcer: "Devloper",
  //   post: "Web Development",
  //   date: "The Web Addict - Mar 4, 2021 - Present",
  //   desc: "• Seeking an engineering position in the field of software development •Searching to improve my experience in creating user interfaces using HTML5, CSS and JavaScript. •Objective To utilize my expertise in programming, to obtain maximum performance.",
  // },

  {
    id: 1,
    image: require("../pic/SamarT.jpg"),
    design: "MS, Computer Science",
    name: "Ms. Samar Fatayri",
    offcer: "Technical Program Manager",
    post: "Web Development",
    date: "Codi_Tech (NGO) - Sep 1, 2018 - Present",
    desc: "Teaching: - Introduction to Computers, - Introduction to Programming Lab  - Introduction to Programming",
  },
  {
    id: 2,
    image: require("../pic/HusseinT.jpg"),
    design: "CCE - Developer",
    name: "Mr. Hussein Shahrour",
    offcer: "Frontend Devloper",
    post: "React Development",
    date: "Acksession - Jan 1, 2020 - Present",
    desc: "• Building reusable components and front-end libraries for future use. • Translating designs and wireframes into high quality code.",
  },
]

export default TestimonialApi
